import {Component, HostBinding, Input} from '@angular/core';
import {SourcePiece} from '../value-source';

/**
 * What a collapsed mapping line - a flat row or a group card's field -
 * takes its value from: a fixed value and its mark while `fixedValue` is
 * set, else an arrow and the source piece by piece (`valueSourceSummary`).
 */
@Component({
  selector: 'app-source-pieces',
  templateUrl: './source-pieces.component.html',
  styleUrls: ['./source-pieces.component.scss'],
  standalone: false,
})
export class SourcePiecesComponent {
  @Input() pieces: readonly SourcePiece[] = [];
  // The fixed value, blank for a pick its picker names; `null` while the
  // line takes its value from a source.
  @Input() fixedValue: string | null = null;
  // Keeps a line of one literal or label and its chip readable in a
  // narrow box: the chip stays whole, and the literal is cut off, or left
  // out where too little of it would show.
  @HostBinding('class.source-pieces--keep-columns')
  @Input() keepColumns = false;
}
